export default __webpack_public_path__ + "static/media/white.8cc41fb6.svg";